import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSwal from 'vue-swal'
import ImageUploader from 'vue-image-upload-resize'
import VModal from 'vue-js-modal'

Vue.use(VueSwal)
Vue.use(ImageUploader)
Vue.use(VModal)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
